<template>
  <div class="uk-card-body_ uk-margin-top">
    <!--шапка-->
    <div
        class="uk-grid uk-grid-collapse uk-flex-middle uk-text-center uk-text-uppercase uk-text-muted uk-text-bold uk-text-small tm-small-stars tm-close-stars"
        data-uk-grid>
      <div class="uk-text-left tm-width-medium">
        <div class="uk-padding-xsmall">
          {{ local_page_keys.pr_week_num_dates }}
        </div>
      </div>
      <div class="uk-width-small">
        <div v-for="(field, fieldKey) in fields" :key="fieldKey">
         <div v-if="field.key === 'weekly-bonus'">
            <div class="uk-padding-xsmall" >
                  <span v-for="iconKey in field.countIcons" :key="iconKey"
                        class="material-icons"
                        :data-uk-tooltip="'title: ' + (field.title ? field.title : '')">
                    {{ field.icon }}
                  </span>
            </div>
         </div>
        </div>
      </div>
      <div class="uk-width-expand">
        <div class="uk-grid uk-grid-collapse uk-flex-middle tm-hide-first-element" :class="'tm-child-width-1-' + countFieldItem" data-uk-grid>
          <div v-for="(field, fieldKey) in fields" :key="fieldKey">
            <div v-show="field.key !== 'weekly-bonus'">
              <div class="uk-padding-xsmall">
                <template v-if="field.icon">
                  <span class="material-icons" :data-uk-tooltip="'title: ' + (field.title ? field.title : '')"
                        v-for="iconKey in field.countIcons" :key="iconKey">
                    {{ field.icon }}
                  </span>
                </template>
                <template v-else-if="field.text">{{ field.text }}</template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="uk-margin-small uk-margin-remove-bottom">
    <div>
      <template v-if="multiRow">
        <div v-for="(itemOuter, index) in items" :key="index">
            <RatingTableItem
            :items="itemOuter"
            :getSeniorQualityIcon="getSeniorQualityIcon"
            :getProRetoucherCommentIcon="getProRetoucherCommentIcon"
            :getData="getData"
            :showQuality = isShowQuality
            :showSloppy = isShowSloppyWork
            :getIsNotEmpty="getIsNotEmpty"
            :local_page_keys="local_page_keys"
            :chosenUserEmail="chosenUserEmail"
            :user_id = "user_id"
            :role="role"
            :notiferForWeeksData="notiferForWeeksData"
            @openOrder="selectOrder"
            :fields="fields"
            :countFieldItem="countFieldItem"
            :choosenRole="choosenRole"
            />
        </div>
      </template>
      <template v-else>
        <RatingTableItem
            :items="items"
            :getSeniorQualityIcon="getSeniorQualityIcon"
            :getProRetoucherCommentIcon="getProRetoucherCommentIcon"
            :getData="getData"
            :showQuality = isShowQuality
            :showSloppy = isShowSloppyWork
            :getIsNotEmpty="getIsNotEmpty"
            :local_page_keys="local_page_keys"
            :chosenUserEmail="chosenUserEmail"
            :user_id = "user_id"
            :role="role"
            @openOrder="selectOrder"
            :fields="fields"
            :countFieldItem="countFieldItem"
            :choosenRole="choosenRole"
        />
      </template>
    </div>
    <hr class="uk-margin-remove">
    <!--кнопка дозагрузки строк-->
    <div class="uk-margin uk-text-center">
      <a href="#"
         @click.prevent="$emit('loadMore')"
         class="uk-button uk-button-success tm-light">
        <md-icon>add</md-icon>
        <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
      </a>
      <a href="#"
         v-show="false"
         @click="$emit('loadMore', true)"
         class="uk-button uk-button-success tm-light">
        <md-icon>add</md-icon>
        <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
      </a>
    </div>
  </div>
</template>

<script>
import RatingTableItem from "@/pages/Dashboard/Components/RatingTableItem";

export default {
  data() {
    return {
      fields: [
        {
          key: 5,
          icon: 'star',
          key_lang: 'pr_5_stars',
          countIcons: 5,
          withOrders: true,
          order: 30,
          role:'all'
        },
        {
          key: 4,
          icon: 'star',
          key_lang: 'pr_4_stars',
          countIcons: 4,
          withOrders: true,
          order: 40,
          role:'all'
        },
        {
          key: 3,
          icon: 'star',
          key_lang: 'pr_3_stars',
          countIcons: 3,
          withOrders: true,
          order: 50,
          role:'all'
        },
        {
          key: 2,
          icon: 'star',
          key_lang: 'pr_2_stars',
          countIcons: 2,
          withOrders: true,
          order: 60,
          role:'all'
        },
        {
          key: 1,
          icon: 'star',
          key_lang: 'pr_1_stars',
          countIcons: 1,
          withOrders: true,
          order: 70,
          role:'all'
        },
        {
          key: 'returned',
          key_lang: 'pr_redo_from_client',
          icon: 'redo',
          countIcons: 1,
          title: 'Redo from client',
          withOrders: true,
          order: 80,
          role:'pro-retoucher'
        },
        {
          key: 'slung',
          key_lang: 'pr_slung',
          icon: 'auto_delete',
          countIcons: 1,
          title: 'slung',
          withOrders: true,
          order: 85,
          role:'retoucher'
        },
        {
          key: 'orders-first',
          key_lang: 'pr_orders_first',
          icon: 'looks_one',
          countIcons: 1,
          title: 'orders-first',
          withOrders: true,
          order: 86,
          role:'retoucher'
        },
        {
          key: 'orders-take',
          key_lang: 'pr_orders_take',
          icon: 'mood_bad',
          countIcons: 1,
          title: 'orders-take',
          withOrders: true,
          order: 87,
          role:'retoucher'
        },
        {
          key: 'slung',
          key_lang: 'pr_slung',
          icon: 'auto_delete',
          countIcons: 1,
          title: 'slung',
          withOrders: true,
          order: 85,
          role:'junior-retoucher'
        },
        {
          key: 'orders-first',
          key_lang: 'pr_orders_first',
          icon: 'looks_one',
          countIcons: 1,
          title: 'orders-first',
          withOrders: true,
          order: 86,
          role:'junior-retoucher'
        },
        {
          key: 'orders-take',
          key_lang: 'pr_orders_take',
          icon: 'mood_bad',
          countIcons: 1,
          title: 'orders-take',
          withOrders: true,
          order: 87,
          role:'junior-retoucher'
        },
        {
          key: 'senior-dislike',
          key_lang: 'pr_senior_dislike',
          icon: 'thumb_down',
          countIcons: 1,
          title: 'Senior dislike',
          withOrders: true,
          order: 90,
          role:'pro-retoucher'
        },
      ],
      local_page_keys: {},
      test: [],
      role:'',
    };
  },
  props: {items: {type: [Array, Object]}, loading: Boolean, individualFields: Array, multiRow: Boolean, selectOrder:{}, chosenUserEmail: String, user_id: Number, notiferForWeeksData:Array, choosenRole: String },
  components: {
    RatingTableItem
  },
  methods: {
    fieldsLangReplaceTitle() {
      let _this = this;
      if (this.fields && this.fields.length > 0) {
        this.fields.forEach(function (field, index) {
          if ('key_lang' in field && field.key_lang in _this.local_page_keys) {
            _this.fields[index]['title'] = _this.local_page_keys[field.key_lang];
          }
        })
      }
    },
    getData(item, rating, key) {
      return item && item.rating && item.rating[rating] && item.rating[rating][key] ? item.rating[rating][key] : '-';
    },
    getIsNotEmpty(item) {
      let isNotEmpty = false;
      let column = null;
      let field = null;
      for (let key in item.rating) {
        column = item.rating[key];
        field = this.fields.filter(el => el.key == key);
        field = field && field[0] ? field[0] : null;
        if (field && field.withOrders) {
          if (column && column.count && column.count > 0) {
            isNotEmpty = true;
          }
        }
      }
      return isNotEmpty;
    },
    getSeniorQualityIcon(order, validUserNyEmail = false, field) {
      let quality = order.senior_retoucher_quality;
      let data = {'icon': '', 'class': ''}
      let isValidUser;

      if (!validUserNyEmail) {
        isValidUser = this.user_id === order.commented_proretoucher;
      } else {
        isValidUser = this.chosenUserEmail === order.commented_proretoucher;
      }

      if (isValidUser && (quality === 'nice-job' || quality === 'good-bad-job')) {
        data = {'icon': 'done', 'class': 'tm-icon-done'}
      } else if (isValidUser && quality === 'bad-job') {
        data = {'icon': 'close', 'class': 'tm-icon-close'}
      } else if (!quality && field !== 5) {
        data = {'icon': 'circle', 'class': 'tm-senior-mark-icon-gray'}
      }

      if(quality === 'nice-job' && (this.role === 'senior-retoucher' || this.role === 'admin'  )) {
        data = {'icon': 'done', 'class': 'tm-icon-done'}
      }
      if (quality && (order.commented_proretoucher && !isValidUser)) {
        data = {'icon': 'people_outline', 'class': 'tm-senior-mark-icon-people'}
      }

      return data;
    },
    getProRetoucherCommentIcon(isOwner) {
      let data = {'icon': 'cached', 'class': 'tm-icon-blue'}
      if (!isOwner && this.role === 'pro-retoucher') {
        data = {'icon': 'feedback', 'class': 'tm-senior-mark-icon-people'}
      }
      return data;
    },
    initFields (role) {
      this.fields = this.fields.filter(field => field.role === 'all' || field.role === role).sort((a, b) => a.order - b.order);
    }
  },
  watch: {
    choosenRole: function (val) {
      this.initFields(val);
    },
  },
  computed: {
    isShowQuality() {
      return this.role === 'pro-retoucher' || this.role === 'admin' || this.role === "mini-admin" || this.role === 'senior-retoucher';
    },
    isShowSloppyWork() {
      return this.role === 'pro-retoucher' || this.role === 'admin' || this.role === "mini-admin" || this.role === 'senior-retoucher';
    },
    countFieldItem() {
      return this.fields.length - 1;
    }
  },
  async created() {
    this.local_page_keys = await this.$filtergetLocalisationPage('pro_retoucher_progress_report');
    this.fields = this.fields.concat(this.individualFields).sort((a, b) => a.order - b.order);
    this.initFields(this.choosenRole);
    this.fieldsLangReplaceTitle();
    this.role = await this.$store.getters['profile/role'];
  },
}
</script>
<style>
  @import '../../../assets/css/uikit/spinner.css';
</style>